<template>
  <modal
    name="validation-modal"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="1050"
    height="auto"
    @before-open="getData"
    :clickToClose="false"
  >
    <div class="modalWrapper">
      <div class="form-row mb-4">
        <div class="col-md-6 mb-4 mb-md-0">
          <div class="content__box">
            <div class="content__box__header pb-2">
              <div class="top__filter align-items-center">
                <ul class="top__filter__ul">
                  <li>Create validation</li>
                </ul>
              </div>
            </div>
            <div class="content__divider"></div>
            <div class="content__box__body">
              <div class="form-group">
                <label class="txt--ss txt--off-white mb-2" for="validation_name"
                  >Name</label
                ><input
                  type="text"
                  name="validation_name"
                  id="validation_name"
                  class="textInputField"
                  placeholder="Validation name"
                  v-model="name"
                />
              </div>
              <div class="form-group">
                <label
                  class="txt--ss txt--off-white mb-2"
                  for="validation_duration"
                  >Duration</label
                ><select
                  name="validation_duration"
                  id="validation_duration"
                  class="textInputField"
                  v-model="duration"
                >
                  <option v-for="(hour,index) in hours" :key="index" :value= hour >{{ hour++ }}Hour</option>
                  <!-- <option value="2">2hr</option>
                  
                  <option value="4">4hr</option> -->
                </select>
              </div>
              <div class="form-group">
                <label
                  class="txt--ss txt--off-white mb-2"
                  for="validation_quantity"
                  >Quantity</label
                ><input
                  type="text"
                  name="validation_quantity"
                  id="validation_quantity"
                  class="textInputField"
                  placeholder="Validation Quantity"
                  v-model.number="quantity"
                  @keypress="checkNumber"
                />
              </div>
              <div v-if="user_role == 'commercial' || (user_role == 'operator' && access_list.validation_access_write == true)">
                <ButtonWithSpinner
                  class="button button--primary button--sm mr-3"
                  :disabled="update_button.disabled"
                  :loading="update_button.loading"
                  :success="update_button.success"
                  @click="create"
                >
                Save</ButtonWithSpinner
                >
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="content__box">
            <div class="content__box__header pb-2">
              <div class="top__filter align-items-center">
                <ul class="top__filter__ul">
                  <li>Validation lists</li>
                </ul>
                <ul class="top__filter__ul search_form_control">
                  <li>
                    <input
                      class="form-control form-control-sm"
                      type="text"
                      placeholder="Search by name"
                      aria-label="Search"
                      v-model="search"
                    />
                  </li>
                </ul>
              </div>
            </div>
            <div class="content__box__body content__box__body__audit__table">
              <div class="table-responsive" style="height:350px;">
                <table class="table table__audit table-borderless">
                  <thead>
                    <tr>
                      <th>Validation Name</th>
                      <th>Duration</th>
                      <th>Quantity</th>
                      <th v-if="validation_delete_access==true">Creator</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr style="cursor: default" v-for="(validation,index) in validation_list" :key="index">
                      <td>{{ validation.name }}</td>
                      <td>{{ validation.duration }}Hour</td>
                      <td>{{ validation.quantity }}</td>
                      <td v-if="validation_delete_access==true">
                        {{validation.validation_creator}}
                      </td>
                      <td>
                        <span class="cursor-pointer mr-2"
                        @click="editValidation(validation)"
                        > Edit </span>
                        <span class="cursor-pointer text-danger mr-2"
                        v-if="validation_delete_access==true"
                        @click="deleteValidation(validation.id)"
                        >
                          Delete
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <infinite-loading
                  @infinite="paginateValidation"
                  :distance="10"
                  v-if="
                    validation_list.length > 0 &&
                    validation_load_more
                  "
                >
                  <div slot="spinner">
                    <div class="d-flex justify-content-center mt-4">
                      <div class="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                  <div slot="no-more"></div>
                  <div slot="no-results">No data found</div>
                </infinite-loading>                
              </div>
              <div v-if="validation_list.length == 0 && validation_loader"
                class="
                  d-flex
                  justify-content-center
                  reports__details--body
                  m-customer--min-height
                "
              >
                <div class="lds-ring">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>              
            </div>
          </div>
        </div>
      </div>
      <!-- Close Modal Cross Icon -->
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>

<script>
import axios from "../../axios";
import ButtonWithSpinner from "@/components/Button";
import _ from 'lodash';

export default {
  name: "ValidationModal",
  components:{
    ButtonWithSpinner,

  },
  data(){
    return{
      name:'',
      hours:24,
      duration:'',
      quantity:'',
      property:[],
      validation_list:[],
      validation_id:'',
      validation_page:1,
      validation_loader:false,
      validation_load_more:false,
      update_button: {
        disabled: false,
        success: false,
        loading: false
      },
      validation_delete_access:true,
      search: "",
      user_role:    '',
      access_list:  {},
    }
  },
  created(){
    this.user_role    = localStorage.getItem("role");
    this.access_list  = JSON.parse(localStorage.getItem("commercial_access_list"));
  },
  watch: {
    search: function (newVal, oldVal) {
      if (newVal.trim() != oldVal.trim()) {
        this.getValidations();
      }
    },
  },
  methods: {
    closeModal() {
      this.validation_id = '';
      this.$modal.hide("validation-modal");
    },
    create(){
      if (this.name == "") {
        this.$toasted.show("Please provide a validation name!", {
            icon: "times-circle",
            className: "error-class",
        });
        return;
      }

      if(window.regularExpressions.specialName.test(this.name) == false) {
        this.$toasted.show("Please provide a valid name for the validation!", {
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      if (this.duration == "") {
        this.$toasted.show("Please provide a validation duration!", {
            icon: "times-circle",
            className: "error-class",
        });
        return;
      }
      if (this.quantity == "") {
        this.$toasted.show("Please provide a validation quantity!", {
            icon: "times-circle",
            className: "error-class",
        });
        return;
      }
      if(this.quantity <= 0) {
        this.$toasted.show("Validation quantity can not be less than or equal to 0!",{
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }
      if(this.quantity > 1000) {
        this.$toasted.show("Validation quantity can not be more than 1000!",{
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }
      this.update_button.disabled = true;
      this.update_button.loading = true;
      this.update_button.success = false;                  
      axios
        .post(window.hostname + "/api/auth/validation/create",{
          name:this.name,
          duration:this.duration,
          quantity:this.quantity,
          property_id:this.property.space_id,
          validation_id:this.validation_id
        })
        .then((res)=>{
          if(res.data.status){
            this.$toasted.show("validation added successfully!", {
                icon: "check-circle",
                className: "success-class",
            });  
            
            this.refresh();
          }
          else {
            this.$toasted.show(res.data.message,{
              icon : 'times-circle',
              className: 'error-class'
            });
          }
          
          this.update_button.disabled = false;
          this.update_button.loading = false;
          this.update_button.success = false;

        })
        .catch((err)=>{
          console.log(err);
          this.update_button.disabled = false;
          this.update_button.loading = false;
          this.update_button.success = false;          
        })
    },
    checkNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      }
      return true;
    },
    getData(e){
      this.validation_id = '';
      this.property=e.params.property_details;
      if(localStorage.getItem("role")=='operator'){
        this.validation_delete_access = false;
      }
      this.refresh();
    },
    getValidations: _.debounce(function() {
      this.validation_loader=true;
      this.validation_list = [];
      this.validation_page = 1;
      this.validation_load_more = true;

      axios
        .post(window.hostname + "/api/auth/validation/list",{
          property_id:this.property.space_id,
          page:this.validation_page,
          search: this.search
        })
        .then((res)=>{
          if(res.status){
            this.validation_loader=false;
            // this.validation_list=res.data.data.validation_list;
            let validation_list=res.data.data.validation_list;
            validation_list.map(val=>{
              this.validation_list.push(val);
            });
            this.validation_page++;
            this.validation_load_more=res.data.data.pagination.load_more == 1 ? true : false;
            console.log(res.data.data.pagination.load_more);
          }

        })
        .catch((err)=>{
          this.validation_loader=false;
          console.log(err);
        });
    },500),
    paginateValidation($state){
      this.validation_loader=true;
        axios
          .post(window.hostname + "/api/auth/validation/list",{
              property_id:this.property.space_id,
              page:this.validation_page,
              search: this.search
          })
          .then((res)=>{
            if(res.status){
              this.validation_loader=false;
              let validation_list=res.data.data.validation_list;
              validation_list.map(val=>{
                this.validation_list.push(val);
              });
              this.validation_page++;
              this.validation_load_more=res.data.data.pagination.load_more == 1 ? true : false;     
            if(this.validation_load_more) {
              $state.loaded();
            }
            else {
              $state.complete();
            }        
            }
            else{
              this.validation_loader=false;
              this.validation_load_more=false;
              this.validation_list=[];
              $state.complete();

            }
          })
          .catch((err)=>{
            $state.error();
            this.validation_loader=false;
            console.log(err);
            this.validation_load_more=false;
            this.validation_list=[];
          })
    },
    refresh(){
      this.validation_list=[];
      this.validation_page =1;
      this.validation_loader=false;
      this.validation_load_more=false;
      this.duration='';
      this.quantity='';
      this.name='';
      this.validation_id = '';
      this.getValidations();
    },
    editValidation(validation){
      this.name=validation.name;
      this.duration=validation.duration;
      this.quantity=validation.quantity;
      this.validation_id=validation.id;
    },
    deleteValidation(id){
      this.$swal({
        title: "Are you sure?",
        text: "Do you want to delete this validation?",
        showCancelButton: true,
      })
      .then((res)=>{
         if (res.value){
          this.axios
            .post(window.hostname + "api/auth/validation/delete", {
              validation_id: id,
          })
          .then((res)=>{
              if (res.data.status) {
                this.$toasted.show(res.data.message, {
                  icon: "check-circle",
                  className: "success-class",
                });
                this.refresh();
              } else {
                this.$toasted.show(res.data.message, {
                  icon: "times-circle",
                  className: "error-class",
                });
                return;
              }
          })
          .catch((err)=>{
            console.log(err);
          })
         }
      })
   
    }  
  },
};
</script>

<style>
</style>